import styled from "styled-components";

export const Curso = styled.div`
  background-color: var(--white);
  display: flex;
  justify-content: center;
  align-items: center;

  #pather-div {
    max-width: 1300px;
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 43px;
    gap: 52px;

    #sec1 {
      display: flex;
      flex-direction: column;
      gap: 10px;

      #solution {
        font-weight: 700;
        font-size: 12px;
        line-height: 122%;
        text-transform: uppercase;
        color: var(--orange);
      }

      h1 {
        font-weight: 700;
        font-size: 24px;
        line-height: 122%;
        color: var(--title);
      }

      #desc {
        font-weight: 700;
        font-size: 14px;
        line-height: 160%;
        color: #011f53;

        #see {
          color: #0a9230;
        }
      }

      #ul {
        font-weight: 700;
        font-size: 14px;
        line-height: 160%;
        color: var(--orange);
        display: flex;
        flex-direction: column;
        gap: 22px;
        margin: 30px 0;

        p {
          svg {
            margin-right: 5px;
            color: #23c350;
          }
        }
      }
    }

    #sec2 {
      p {
        font-weight: 700;
        font-size: 14px;
        line-height: 160%;
        color: var(--title);
        margin-bottom: 50px;
      }

      ol {
        font-weight: 500;
        font-size: 14px;
        line-height: 160%;
        color: var(--orange);

        display: flex;
        flex-direction: column;
        gap: 15px;
      }
    }
  }

  @media (min-width: 601px) {
    #pather-div {
      flex-direction: row;

      #sec1 {
        width: 55%;

        #solution {
          font-size: 16px;
          line-height: 140%;
        }

        h1 {
          font-size: 40px;
          line-height: 140%;
        }

        #desc {
          font-size: 16px;
          line-height: 160%;
        }

        #ul {
          p {
            font-size: 16px;
            line-height: 160%;
          }
        }
      }

      #sec2 {
        border: 2px solid #c8d2df;
        border-radius: 2px;
        padding: 25px 45px;
        width: 45%;

        p {
          font-size: 16px;
          margin-bottom: 5px;
        }

        ol {
          gap: 0;

          li {
            font-size: 15px;
            line-height: 220%;
          }
        }
      }
    }
  }
`;
